<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div class="max-w-md w-full bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center">
      <h1 class="text-2xl font-bold text-gray-900">Unauthorized</h1>
      <p class="text-sm text-gray-500 mt-3">
        You do not have permission to access this page.
      </p>
      <div class="mt-6 flex justify-center gap-3">
        <router-link
          to="/home"
          class="px-4 py-2 rounded bg-black text-white text-sm font-semibold hover:bg-gray-800"
        >
          Go to Assets
        </router-link>
        <router-link
          to="/profile"
          class="px-4 py-2 rounded border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-gray-100"
        >
          My Profile
        </router-link>
      </div>
    </div>
  </div>
</template>
